export function ExpandIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M14 9.83333V11.3C14 12.4201 14 12.9802 13.782 13.408C13.5903 13.7843 13.2843 14.0903 12.908 14.282C12.4802 14.5 11.9201 14.5 10.8 14.5H9.33333M6.66667 2.5H5.2C4.0799 2.5 3.51984 2.5 3.09202 2.71799C2.71569 2.90973 2.40973 3.21569 2.21799 3.59202C2 4.01984 2 4.5799 2 5.7V7.16667M10 6.5L14 2.5M14 2.5H10M14 2.5V6.5M6 10.5L2 14.5M2 14.5H6M2 14.5L2 10.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
